import { api } from "@/config/api-fetch";
import { useQuery } from "@tanstack/react-query";

export interface QueueStats {
	total: number;
	pending: number;
	processing: number;
	completed: number;
	failed: number;
}

export interface CronStatus {
	is_healthy: boolean;
	health_message: string;
	last_check: number | null;
	is_running: boolean;
	queue_stats: QueueStats;
}

export function useCronStatus() {
	return useQuery<CronStatus>({
		queryKey: ["cron-status"],
		queryFn: async () => api.get<CronStatus>("/auto-posting/cron-status"),
		refetchInterval: 30000,
	});
}
